import { render } from "./SpecificationDetails.vue?vue&type=template&id=71e532b8&scoped=true"
import script from "./SpecificationDetails.vue?vue&type=script&lang=js"
export * from "./SpecificationDetails.vue?vue&type=script&lang=js"

import "./SpecificationDetails.vue?vue&type=style&index=0&id=71e532b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71e532b8"

export default script